import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { createTheme, responsiveFontSizes, ThemeProvider } from "@mui/material/styles";
import {
  Box,
  Button,
  ButtonBase,
  Chip,
  Fade,
  IconButton,
  Grid,
  Stack,
  Tab,
  TextField,
  TextareaAutosize,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { Female, Male } from "@mui/icons-material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { AddCircle, ArrowBackIosNew, RemoveCircle } from "@mui/icons-material";
import { getAdaptivFontSize, getRoute } from "../utils/CommonUtils";
import { AppSingleton, data_list } from "../services/user_config";

const ExerciseSelectionCard = React.forwardRef(
  ({ exercise_id, title, subtitle, duration, calories, diffculty, tags, trainer, imageUrl, videoUrl, style }, ref) => {
    const navigate = useNavigate();
    const theme = useTheme();
    // const backgroundColor = "#333333";
    // const chipBackgrund = "#222222";
    const h = "256px";

    return (
      <ButtonBase
        sx={{ width: "100%", mb: "2%", ...style }}
        ref={ref}
        onClick={() => navigate(`${getRoute("pose-mirror")}/${exercise_id}`)}
      >
        <Box
          sx={{
            width: "100%",
            backgroundColor: theme.palette.card.main,
            borderRadius: 4,
            boxShadow: "0 3px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Grid container>
            <Grid item xs={7}>
              <Box
                sx={{
                  m: getAdaptivFontSize(window.screen.width < 768 ? 2 : 4),
                  height: h,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography
                  color="primary"
                  align="left"
                  sx={{
                    fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(16) : getAdaptivFontSize(32)),
                  }}
                >
                  {title}
                </Typography>
                <Stack direction="row">
                  <Chip label={`${Math.ceil(duration / 60)}分鐘`} sx={{ backgroundColor: "transparent" }} />
                  {/* <Chip label={`~${calories}千卡`} sx={{ backgroundColor: "transparent" }} /> */}
                  <Chip label={diffculty} sx={{ backgroundColor: "transparent" }} />
                </Stack>
                <Stack direction="row">
                  {tags.map((tag, i) => (
                    <Chip key={`${exercise_id}-${i}`} label={tag} sx={{ backgroundColor: theme.palette.chip.main }} />
                  ))}
                </Stack>
                <Typography
                  align="left"
                  color="primary"
                  sx={{
                    mt: "auto",
                    fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(12) : getAdaptivFontSize(24)),
                  }}
                >
                  {trainer}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={5} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <Box
                sx={{
                  // display: "inline-block",
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  // padding: "8px",
                  width: "100%",
                  // height: "auto",
                  // width: h,
                  height: h,
                  border: "none",
                  boxShadow: `0 0 16px 16px ${theme.palette.card.main} inset`,
                  backgroundImage: `url('${imageUrl}')`,
                  backgroundPosition: "center",
                }}
              ></Box>
            </Grid>
          </Grid>
        </Box>
      </ButtonBase>
    );
  }
);

const ListingPage = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [currentTab, setCurrentTab] = useState("avatar1");

  return (
    // <ThemeProvider theme={theme}>
    <Box sx={{ backgroundColor: theme.palette.background.main }}>
      <Box
        sx={{
          top: 0,
          position: "fixed",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          height: "96px",
          backgroundColor: theme.palette.background.main,
          zIndex: 2,
        }}
      >
        <Button
          startIcon={<ArrowBackIosNew />}
          onClick={() => {
            navigate(`${getRoute("landing-page")}`);
          }}
          sx={{ ml: 4 }}
        >
          返回
        </Button>
        <Typography
          color="primary"
          sx={{
            fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(12) : getAdaptivFontSize(24)),
          }}
        >
          選擇練習
        </Typography>
        <ToggleButtonGroup
          value={currentTab}
          exclusive
          onChange={(evt, newVal) => {
            if (newVal) {
              setCurrentTab(newVal);
            }
          }}
          sx={{ mr: 2 }}
        >
          <ToggleButton value="avatar1">
            <Typography sx={{ color: "#FFF" }}>元氣大叔</Typography>
          </ToggleButton>
          <ToggleButton value="avatar2">
            <Typography sx={{ color: "#FFF" }}>活力小姐</Typography>
          </ToggleButton>
          <ToggleButton value="helper1">
            <Typography sx={{ color: "#FFF" }}>葵心</Typography>
          </ToggleButton>
          <ToggleButton value="helper2">
            <Typography sx={{ color: "#FFF" }}>玉娟</Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
      <Box sx={{ pt: "96px", pl: "2%", pr: "2%", overflow: "auto" }}>
        {data_list
          .filter((data) => data.type === currentTab)
          .map((data, i) => (
            <Fade
              key={`${data.exercise_id}-fade`}
              in={true}
              style={{
                transitionDelay: `${i * 250}ms`,
              }}
              {...{ timeout: 500 }}
            >
              <ExerciseSelectionCard key={data.exercise_id} {...data} />
            </Fade>
          ))}
      </Box>
    </Box>
    // </ThemeProvider>
  );
};

const f = () => {};

export { ListingPage, f };
